@if (pageData() !== null && filteredContentSections() !== null && searchResultContent()) {
  <div class="row full-width-bg" id="component-top">
    <div class="col">
      <app-breadcrumbs [breadcrumbs]="breadcrumbs()"></app-breadcrumbs>
    </div>
  </div>
  <div
    (inViewportAction)="handleTabsInViewport($event)"
    [inViewportOptions]="{threshold: 0}"
    class="tabs-viewport-marker full-width-bg"
    inViewport
  >
    <div [ngStyle]="placeholderStyle()"></div>
    <div [ngClass]="topSectionCssClass()"
         class="top-section bg-white border-b-2 border-b-grey-9 flex justify-center items-start"
         id="top-section-container">
      <div class="max-w-[1184px] w-full">

        <div class="flex flex-col mt-4 lg:flex-row gap-5 lg:gap-6">
          <div class="flex flex-col gap-4">
            <h1 [innerHTML]="pageData().title.rendered"
                class="text-3xl md:text-4xl text-grey-0 main-title"></h1>
            <div [innerHTML]="pageData().acf.description" class="text-base text-grey-0 main-desc"></div>
            <app-search-content-search [pageType]="pageType()"
                                       [title]="pageData().title.rendered"></app-search-content-search>
          </div>
          <div
            class="hidden lg:inline-block lg:basis-[23.5rem] w-full h-60 relative rounded overflow-hidden main-img">
            <app-media-item
              [image]="pageData().acf.backgroundImageMobile"
              [isPriority]="true"
              class="h-full w-full"
            ></app-media-item>
          </div>
        </div>

        <div class="tabs-container min-h-12">
          <nav [tabPanel]="tabPanel" mat-align-tabs="start" mat-stretch-tabs="false" mat-tab-nav-bar>
            @for (link of tabs(); track link.label; let i = $index) {
              <a mat-tab-link
                 (click)="cpruTabsService.handleTabsIndexChange(link.name)"
                 [active]="highlightedSection() === link.name"> {{ link.label }} </a>
            }
          </nav>
          <mat-tab-nav-panel #tabPanel></mat-tab-nav-panel>
        </div>
      </div>
    </div>
  </div>

  <div class="row mt-4">
    <div class="col">
      <div class="flex flex-col gap-12 md:gap-3">


        @for (section of filteredContentSections(); track section.id; let i = $index) {
          <section id="section-{{section.button.value}}">
            <app-search-content-text-section [section]="section"></app-search-content-text-section>
          </section>

          @if (i === 1) {
            <section id="section-ad" class="-mt-12 md:-mt-3">
              <app-search-content-ad-v2></app-search-content-ad-v2>
            </section>
          }
        }

        @if (!adCampaignOwner() || adCampaignOwner() === 0) {
          <section class="show-on-mobile -mt-12 md:-mt-3"
                   id="section-booktimenow">
            <app-book-time-now-widget
              [careServiceId]="searchResultContent()?.careServiceType?.id"
              [careServiceName]="searchResultContent()?.careServiceType?.name"
              [careServiceTypeUrlPath]="searchResultContent()?.careServiceType?.urlPath"
              [lat]="lat()"
              [lon]="lon()"
              [negativeTop]="'mt-12 md:mt-3'"
              [pageType]="pageType()"
              [symptomId]="searchResultContent()?.symptom?.id"
              [symptomName]="searchResultContent()?.symptom?.name"
              [symptomUrlPath]="searchResultContent()?.symptom?.urlPath"
              [theme]="BookTimeNowThemeEnum.SEARCH_CONTENT_PAGE"
              [useExpand]="true"
            ></app-book-time-now-widget>
          </section>
        }

        @if (!isMobile()) {
          <section class="show-on-desktop" id="section-summary-desktop">
            <app-search-content-summary
              [authorName]="pageData().acf?.authorName"
              [author]="pageData().acf?.author"
              [date]="pageData().date"
              [factChecker]="pageData().acf?.factChecker"
              [modified]="pageData().modified"
              [sources]="pageData().acf?.sources"
            ></app-search-content-summary>
          </section>
        }

      </div>
    </div>

    <div class="col-slg mt-3 lg:mt-0">
      <div class="flex flex-col gap-12 md:gap-3">

        @if (!adCampaignOwner() || adCampaignOwner() === 0) {
          <section class="show-on-desktop -mt-3"
                   id="section-booktimenow-sidebar">
            <app-book-time-now-widget
              [careServiceId]="searchResultContent()?.careServiceType?.id"
              [careServiceName]="searchResultContent()?.careServiceType?.name"
              [careServiceTypeUrlPath]="searchResultContent()?.careServiceType?.urlPath"
              [lat]="lat()"
              [lon]="lon()"
              [negativeTop]="'mt-3'"
              [pageType]="pageType()"
              [symptomId]="searchResultContent()?.symptom?.id"
              [symptomName]="searchResultContent()?.symptom?.name"
              [symptomUrlPath]="searchResultContent()?.symptom?.urlPath"
              [theme]="BookTimeNowThemeEnum.SEARCH_CONTENT_PAGE"
              [useExpand]="true"
              [useSingleColLayout]="true"
            ></app-book-time-now-widget>
          </section>
        }

        @if (pageData().acf.factsSections) {
          <section id="section-facts">
            <app-search-content-facts-v2
              [factsSections]="pageData().acf.factsSections"
              [title]="pageData().title.rendered"
            ></app-search-content-facts-v2>
          </section>
        }

        <section id="section-places">
          <app-search-content-places
            [careServiceTypeUrlPath]="searchResultContent()?.careServiceType?.urlPath"
            [pageType]="pageType()"
            [searchForLabel]="searchForLabel()"
          ></app-search-content-places>
        </section>

        @if (relatedItems() && relatedItems().length > 0) {
          <section id="section-causes">
            <app-search-content-related-causes-v2
              [relatedField]="relatedField()"
              [relatedItems]="relatedItems()"
            ></app-search-content-related-causes-v2>
          </section>
        }

        @if (hideBlog() !== true) {
          <section id="section-blog">
            <app-search-content-related-blog-v2
              [mainCareProviderUnitTypeId]="pageData().acf.mainCareProviderUnitType?.term_id ?? pageData().acf.mainSymptom?.term_id"
            ></app-search-content-related-blog-v2>
          </section>
        }

        @if (isMobile()) {
          <section class="show-on-mobile" id="section-summary-mobile">
            <app-search-content-summary
              [authorName]="pageData().acf?.authorName"
              [author]="pageData().acf?.author"
              [date]="pageData().date"
              [factChecker]="pageData().acf?.factChecker"
              [modified]="pageData().modified"
              [sources]="pageData().acf?.sources"
            ></app-search-content-summary>
          </section>
        }

      </div>
    </div>
  </div>
}

